export default __webpack_public_path__ + "alberta-monitoring.8952feb30d3ccd741ee4.svg";